module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogSubCategories":{"heading":"Kategorie"}},"en":{"CatalogSubCategories":{"heading":"Category"}}}')
  delete Component.options._Ctor
}
